<template>
  <div class="home">
    <div class="top">
    </div>
    <div class="details">
      <div style="width: 90%;margin-left: 5%;padding-top: 80px">
        <div style="display: flex">
          <div class="title">{{ title }}</div>
          <el-button style="height: 50px;margin-top: 40px;margin-left: 80%;background-color: #bfbfbf" @click="back()">返 回</el-button>
        </div>
        <div style="display: flex">
          <div class="name">TENDER INFORMATION</div>
          <div style="width: 70%">
            <el-divider></el-divider>
          </div>
        </div>
        <div v-html="article" style="padding-bottom: 2rem;min-height: 47vh"></div>
        <div style="padding-top: 20px" v-if="fileList.length>0">
          附件：
          <div v-for="item in fileList" :key="item.id" @click="download(item)" style="cursor: pointer;">{{item.fileName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getArticle} from "@/api/article";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "details",
  data(){
    return {
      title:undefined,
      engTitle:undefined,
      article:undefined,
      fileList:[]
    }
  },
  mounted() {
    getArticle({id:this.$route.query.id}).then(res=>{
      this.article=res.data.content
      if(res.data.category==4){
        this.title='信息公示'
        this.engTitle='INFORMATION'
      }else if(res.data.category==5){
        this.title='结果公示'
        this.engTitle='RESULT PUBLICITY'
      }
      this.fileList=res.data.attachments
    })
  },
  methods:{
    async  download(item){
      try {
        const response = await fetch(item.fileUrl);
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = item.fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(downloadUrl);
        link.remove();
      } catch (error) {
        console.error('下载文件时发生错误:', error);
      }
    },
    back(){
      this.$router.push('/tendering')
    },
  }
}
</script>

<style scoped>
.details{
  width: 70%;
  background-color: white;
  margin-left: 15%;
}
.home{
  width: 100%;
  background-color: #efefef;
}
.title {
  margin-top: 40px;
  height: 50px;
  width: 120px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  background-color: #234C9C;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  width: 30%;
  color: #AAAAAA;
  font-size: 24px;
  margin-top: 10px;
}
</style>
